module.exports = __webpack_public_path__ + "static/first_bg-8d88c99046e2173a3cd45adb4d9aa7e1.jpg";